<template>
	<div id="international_detail">
		<div class="block">
			<el-carousel height="900px" arrow="never">
				<el-carousel-item v-for="item in banner_list" :key="item">
					<img :src="item">
				</el-carousel-item>
			</el-carousel>
			<div class="bannerInfo">
				<div class="banner_top_info">
					<div class="top_logo_intro">
						<div class="banner_yixilogo"><img src="@/assets/imgs/yixi_logo_square.png" ></div>
						<div class="top_intro" v-for="(item,i) in barContentList" :key="item">
							<div class="barInfo_item" :class="{'bar_active':(active_bar == i)}" @click="changebar(i)">{{item}}</div>
							<div v-if="item != 'Contact us'" class="item_dian">·</div>
						</div>
					</div>
					<div class="languages_tab" @click="language_tab()">
						<div :class="{'active_language':langguageshow,'unactive':!langguageshow,}">EN</div>
						<div class="active_language">&nbsp;/&nbsp;</div>
						<div :class="{'active_language':!langguageshow,'unactive':langguageshow,}">日本語</div>
					</div>
				</div>
			</div>
			<div class="banner_content">
				<div class="slogan1">Get Inspired</div>
				<div class="slogan2">Humanity · Technology · Daydreams</div>
				<div class="content_btn" @click="to_yixiweb()">Visit Our Homepage</div>
			</div>
			<div class="internationalContent">
				<div class="navigationBar" :class="{ 'barfixed': isFixed }" v-show="isFixed">
					<div class="bar_yixilogo"><img src="@/assets/imgs/yixi_logo_square.png"></div>
					<div class="barInfo" v-for="(item,i) in barContentList" :key="item">
						<div class="barInfo_item" :class="{'bar_active':(active_bar == i)}" @click="changebar(i)">{{item}}</div>
						<div v-if="item != 'Contact us'" class="item_dian">·</div>
					</div>
				</div>
				<div class="aboutYixi scroll-item" id="scrollItem0">
					<div class="info_title">
						<div class="square4"></div>
						<div class="square6"></div>
						<div class="square10"></div>
						<div class="square_title">About YiXi</div>
						<div class="square10"></div>
						<div class="square6"></div>
						<div class="square4"></div>
					</div>
					<div class="aboutYixi_info">
						<div class="aboutYixi_img">
							<img :src="aboutyixiImg">
						</div>
						<div class="aboutYixi_intro" v-html="yixi_intro"></div>
					</div>
				</div>
				<div class="yixiTallks scroll-item" id="scrollItem1">
					<div class="info_title">
						<div class="square4"></div>
						<div class="square6"></div>
						<div class="square10"></div>
						<div class="square_title">YiXi talks</div>
						<div class="square10"></div>
						<div class="square6"></div>
						<div class="square4"></div>
					</div>
					<div class="yixiTallks_info">
						<div class="yixiTallks_bar">
							<div class="yixiTallks_bar_info" v-for="(item,i) in Tallks_barList" :key="i">
								<div class="yixiTallks_bar_item" :class="{'yixiTallks_bar_active':(Tallks_bar == i)}" 
								@click="changeTallks_bar(i)">{{item}}</div>
								<div class="yixiTallks_bar_dian"
								v-if="Tallks_barList.length -1 !=i "
								>·</div>
							</div>
						</div>
						<div class="yixiTallks_swiper">
							<swiper class="swiper" :options="swiperOpt" ref="swiper">
							  <swiper-slide class="swiper-item" v-for="(enitem,i) in english_videos" :key="i+'en'">
								  <div class="swiper_item_content">
									  <div class="video_item" @click="tospeech_detail(item)" v-for="(item,i) in enitem" :key="i">
										  <div class="videoItem_cover">
											  <div class="videoItem_title">{{item.title}}</div>
											  <img :src="item.video_cover" >
										  </div>
										  <div class="videoItem_info">
											  <div class="speakerAvatar">
												  <img :src="item.speaker_avatar">
											  </div>
											  <div class="speakerName">{{item.speaker_name}}</div>
											  <div class="speakerIntro">{{item.speaker_intro}}</div>
										  </div>
									  </div>
								  </div>
							  </swiper-slide>
							  <swiper-slide class="swiper-item" v-for="(jaitem,i) in japanese_videos" :key="i+'ja'">
								  <div class="swiper_item_content">
									  <div class="video_item" @click="tospeech_detail(item)" v-for="(item,i) in jaitem" :key="i">
										  <div class="videoItem_cover">
											  <div class="videoItem_title">{{item.title}}</div>
											  <img :src="item.video_cover" >
										  </div>
										  <div class="videoItem_info">
											  <div class="speakerAvatar"><img :src="item.speaker_avatar"></div>
											  <div class="speakerName">{{item.speaker_name}}</div>
											  <div class="speakerIntro">{{item.speaker_intro}}</div>
										  </div>
									  </div>
								  </div>
							  </swiper-slide>
							  <swiper-slide class="swiper-item" v-for="(otitem,i) in other_speech_items" :key="i+'ot'">
								  <div class="swiper_item_content">
									  <div class="video_item" @click="tospeech_detail(item)" v-for="(item,i) in otitem" :key="i">
										  <div class="videoItem_cover">
											  <div class="videoItem_title">{{item.title}}</div>
											  <img :src="item.video_cover" >
										  </div>
										  <div class="videoItem_info">
											  <div class="speakerAvatar"><img :src="item.speaker_avatar"></div>
											  <div class="speakerName">{{item.speaker_name}}</div>
											  <div class="speakerIntro">{{item.speaker_intro}}</div>
										  </div>
									  </div>
								  </div>
							  </swiper-slide>
							</swiper>
							<div class="episode swiper-button-prev international-btn-prev" @click="prevBtn()"></div>
							<div class="episode swiper-button-next international-btn-next" @click="nextBtn()"></div>
						</div>
					</div>
					
				</div>
				<div class="videoPrograms scroll-item" id="scrollItem2">
					<div class="info_title">
						<div class="square4"></div>
						<div class="square6"></div>
						<div class="square10"></div>
						<div class="square_title">Video programs</div>
						<div class="square10"></div>
						<div class="square6"></div>
						<div class="square4"></div>
					</div>
					<div class="videoPrograms_content">
						<div @click="to_pregrans(item)" class="videoPrograms_content_item" v-for="(item,i) in videoProgramsList" :key="i">
							<img :src="item.bgimg">
						</div>
					</div>
				</div>
				<div class="contactUs scroll-item" id="scrollItem3">
					<div class="info_title">
						<div class="square4"></div>
						<div class="square6"></div>
						<div class="square10"></div>
						<div class="square_title">Contact us</div>
						<div class="square10"></div>
						<div class="square6"></div>
						<div class="square4"></div>
					</div>
					<div class="contactUs_content">
						<div class="concat_methods">
							<div class="contactUs_content_item" v-for="(item,i) in contactUsList" :key="i" @click="yiixto(item.url)">
								<i class="icon-item" style="width: 25px;height: 25px;display: block;"><img :src="item.icon"></i>
								<i class="icon-item icon-item-red" style="width: 25px;height: 25px;display: block;"><img :src="item.iconred"></i>
								{{item.name}}
							</div>
						</div>
						<div class="concat_qcord">
							<div class="concat_qcord_item" v-for="(item,i) in qrcodeList" :key="i">
								<img :src="item.qrcode_img" alt="">
								<div class="qcord_item_title">{{item.title}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import requestApi from '@/service';
export default {
	data() {
		return {
			isFixed:false,
			langguageshow:true,
			barContentList:['About','YIXI talks','Discover','Contact us'],
			active_bar:0,
			Tallks_barList:['English','日本語(Japanese)'],
			aboutyixiImg:require('../../src/assets/imgs/yixiInternational.png'),
			videoProgramsList:[
				{bgimg:require('../../src/assets/imgs/yixitalks.png'), path: 'speech'},
				{bgimg:require('../../src/assets/imgs/yixipaidprogram.png'), path: 'wanxiang'},
				{bgimg:require('../../src/assets/imgs/yixichatshow.png'), path: 'zhiya'},
				{bgimg:require('../../src/assets/imgs/yixidocumentary.png'), path: 'record'},
			],
			Tallks_bar:0,
			swiperpage:0,
			swiperOpt:{
				slidesPerView: 1,
				slidesPerGroup: 1,
				// loop:true,
				navigation: {
				  prevEl: '.swiper-button-prev',
				  nextEl: '.swiper-button-next',
				},
			},
			contactUsList:[
				{name:'Email：admin@yixi.tv',
				icon:require('../../src/assets/imgs/email-icon.png'),
				iconred:require('../../src/assets/imgs/email-red-icon.png')},
				{name:'Podcast：@一席YiXi',
				url: 'https://podcasts.apple.com/cn/podcast/%E4%B8%80%E5%B8%ADyixi/id676106704',
				icon:require('../../src/assets/imgs/podcast-icon.png'),
				iconred:require('../../src/assets/imgs/podcast-red-icon.png')},
				// {name:'Phone：',
				// icon:require('../../src/assets/imgs/phone-icon.png'),
				// iconred:require('../../src/assets/imgs/phone-red-icon.png')},
				{name:'YouTube：@yixi2028',
				url:"https://www.youtube.com/@yixi2028",
				icon:require('../../src/assets/imgs/youtube-icon.png'),
				iconred:require('../../src/assets/imgs/youtube-red-icon.png')},
				{name:'Weibo：@一席YiXi',
				url: 'https://weibo.com/yixiclub',
				icon:require('../../src/assets/imgs/weibo-icon.png'),
				iconred:require('../../src/assets/imgs/weibo-red-icon.png')},
			],
			qrcodeList:[
				{title:'Download YIXI App',qrcode_img:require('../../src/assets/imgs/qrcode/appDownload.png')},
				{title:'Follow WeChat Official Account',qrcode_img:require('../../src/assets/imgs/qrcode/wechat.jpg')}
			],
			banner_list:[],//头图列表
			yixi_introArr:[],
			yixi_intro:'',//一席介绍词
			english_videos:[],
			japanese_videos:[],
			yixi_intro_list:[],
			other_speech_items:[],
		}
	},
	watch:{
		langguageshow(val) {
			if(val) {
				this.yixi_intro = this.yixi_introArr[0]
			}else {
				this.yixi_intro = this.yixi_introArr[1]
			}
		}
	},
	computed:{
		swiper() {
		    return this.$refs.swiper.swiper;
		},
	},
	mounted() {
	  window.addEventListener('scroll', this._scrollEvent,true);
	},
	destroyed() {
	  window.removeEventListener('scroll', this._scrollEvent);
	},
	created() {
		this.get_international()
	},
	methods:{	
		get_international() {
			requestApi('/v3/api/admin/intl_synthesize/').then(res => {
				this.banner_list = res.banner_list
				this.yixi_introArr = res.yixi_intro_list
				this.yixi_intro = this.yixi_introArr[0]
				this.english_videos = res.english_speech_items
				this.japanese_videos = res.japanese_speech_items
				this.other_speech_items = res.other_speech_items
				this.yixi_intro_list = res.yixi_intro_list
				if(this.other_speech_items.length > 0){
					this.Tallks_barList = ['English','日本語(Japanese)','Other languages']
				}
			})
		},
		prevBtn() {
			this.swiperpage -- 
			if(this.english_videos.length < this.swiperpage < this.english_videos.length + this.japanese_videos.length) {
				this.Tallks_bar = 1
			}
			if(this.swiperpage < this.english_videos.length) {
				this.Tallks_bar = 0
			}
		},
		nextBtn() {
			this.swiperpage ++ 
			if(this.swiperpage == this.english_videos.length + this.japanese_videos.length) {
				this.Tallks_bar = 2
			}
			if(this.swiperpage == this.english_videos.length) {
				this.Tallks_bar = 1
			}
			
		},
		_scrollEvent() {
			var scrollTop =
			        window.pageYOffset ||
			        document.documentElement.scrollTop ||
			        document.body.scrollTop
			  if (scrollTop > 80) {
				  this.isFixed = true
				} else {
				  this.isFixed = false
				}
			let scrollItems = document.querySelectorAll('.scroll-item')
			  for (let i = scrollItems.length - 1; i >= 0; i--) {
				// 判断滚动条滚动距离是否大于当前滚动项可滚动距离
				let judge = scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop + 800
				if (judge) {
				  this.active_bar = i
				  break
				}
			}
		},	
		language_tab() {
			this.langguageshow = !this.langguageshow;
			if(this.langguageshow) {
				this.Tallks_bar = 0
				this.swiperpage = 0
				this.$refs.swiper.swiperInstance.slideTo(0, 500, false);
			}else {
				this.Tallks_bar = 1
				this.swiperpage = this.english_videos.length
				this.$refs.swiper.swiperInstance.slideTo(this.english_videos.length, 500, false);
			}
		},
		to_yixiweb(){
			window.open(`${process.env.VUE_APP_URL}/#/home`)
		},
		changebar(index) {
			if(this.active_bar !== index) {
				document.getElementById('scrollItem' + index).scrollIntoView({ behavior: "smooth", block: 'start' });
			}
		},
		changeTallks_bar(i) {
			if(this.Tallks_bar !== i) {
				if(i == 0) {
					this.$refs.swiper.swiperInstance.slideTo(i, 500, false);
				}
				if(i == 1) {
					this.swiperpage = this.english_videos.length
					this.$refs.swiper.swiperInstance.slideTo(this.english_videos.length, 500, false);
				}
				if(i == 2) {
					this.swiperpage = this.english_videos.length + this.japanese_videos.length
					this.$refs.swiper.swiperInstance.slideTo(this.english_videos.length + this.japanese_videos.length, 500, false);
				}
				this.Tallks_bar = i
			}
		},
		tospeech_detail(data) {
			this.$router.push({
			  path: '/speech/detail',
			  query: {
			    id: data.speech_id,
			  },
			});
		},
		to_pregrans(data) {
			const routeUrl = this.$router.resolve({path:data.path});
			window.open(routeUrl.href, '_blank')
		},
		yiixto(url) {
			if(url) {
				window.open(url)
			}
		},
	},
}
</script>

<style scoped lang="scss">
#international_detail {
	width: 100%;
	height: 100%;
}
.block {
	background: #fff;
	margin: 0 auto;
	width: 1440px;
	height: 900px;
	background: radial-gradient(60.52% 73.13% at 62.15% 50%, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 74.61%, rgba(0, 0, 0, 0.7) 100%);
	position: relative;
}
.bannerInfo {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 3;
	.banner_top_info {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: HYXinRenWenSongW;
		padding: 70px 80px 0;
		box-sizing: border-box;
		.top_logo_intro {
			display: flex;
			align-items: center;
		}
		.banner_yixilogo {
			width: 50px;
			height: 50px;
			margin-right: 30px;
		}
		.top_intro {
			display: flex;
			font-size: 15px;
			line-height: 20px;
			color: #BFBFBF;
			.barInfo_item {
				cursor: pointer;
				&:hover{
					color: #DA3F34;
				}
			}
			// margin-left: 30px;
		}
		.item_dian {
			margin: 0 3px;
			width: 15px;
			text-align: center;
		}
		.languages_tab {
			width: 90px;
			display: flex;
			align-items: flex-end;
			justify-content: space-around;
			cursor: pointer;
			.active_language {
				font-size: 18px;
				color: #fff;
				line-height: 24px;
			}
			.unactive {
				font-size: 12px;
				color: #BFBFBF;
				line-height: 20px;
			}
		}
		
	}
}
.banner_content {
	position: absolute;
	top: 335px;
	left: 160px;
	z-index: 3;
	font-family: HYXinRenWenSongW;
	color: #FFFFFF;
	text-shadow: 0px 2px 4px rgba(194, 201, 215, 0.397249);
	.slogan1 {
		font-size: 40px;
		line-height: 60px;
		letter-spacing: 3px;
		margin-bottom: 20px;
	}
	.slogan2 {
		font-size: 25px;
		line-height: 40px;
		letter-spacing: 1px;
		margin-bottom: 40px;
	}
	.content_btn {
		font-family:'PingFang SC';
		box-sizing: border-box;
		width: 220px;
		font-weight: 400;
		font-size: 18px;
		line-height: 25px;
		padding: 10px 20px;
		background:#DA3F34;
		border-radius: 50px;
		cursor: pointer;
		border: 2px solid #DA3F34;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}
	.content_btn:hover {
		color:#DA3F34;
		background-color: #FFFFFF;
		// border: 2px solid #DA3F34;
		box-sizing: border-box;
	}
	
}
.internationalContent {
	.navigationBar {
		height: 60px;
		background: #FFFFFF;
		box-sizing: border-box;
		border: 1px solid #DDDDDD;
		display: flex;
		align-items: center;
		padding-left: 80px;
		.bar_yixilogo {
			width: 30px;
			height: 30px;
			margin-right: 50px;
		}
		.barInfo {
			display: flex;
			color: #666;
			font-family: HYXinRenWenSongW;
			font-size: 15px;
			.item_dian {
				margin: 0 3px;
				width: 15px;
				text-align: center;
			}
			.barInfo_item {
				height: 30px;
				box-sizing: border-box;
				cursor: pointer;
				&:hover{
					color: #DA3F34;
				}
			}
			.bar_active {
				color: #DA3F34;
				border-bottom: 1px solid #DA3F34;
			}
		}
	}
	.barfixed {
		position: fixed;
		width: 100%;
		padding-left: calc((100% - 1440px) / 2 + 60px);
		top: 0;
		left: 0;
		z-index: 88;
	}
	.aboutYixi {
		background: #FFFFFF;
		padding: 30px 0 120px 0;
		.aboutYixi_info {
			width: 100%;
			height: 484px;
			display: flex;
			align-items: center;
			margin-top: 50px;
			background: url('../../src/assets/imgs/yixiInternationalRight.png') no-repeat;
			background-size: 95px 215px;
			background-position: right center;
		}
		.aboutYixi_img {
			width: 665px;
			height: 100%;
		}
		.aboutYixi_intro {
			width: 604px;
			margin-left: 36px;
			font-family: 'PingFang SC';
			font-style: normal;
			font-weight: 300;
			font-size: 16px;
			line-height: 28px;	
			color: #333333;
			height: 100%;
			
		}
	}
	.yixiTallks {
		background: #f5f5f5;
		padding-top: 90px;
		padding-bottom: 60px;
		.yixiTallks_info {
			.yixiTallks_bar {
				display: flex;
				justify-content: center;
				margin-top: 28px;
			}
			.yixiTallks_bar_info {
				display: flex;
				.yixiTallks_bar_item {
					padding-bottom: 3px;
					font-size: 18px;
					line-height: 24px;
					font-family: 'HYXinRenWenSongW';
					color: #666666;
					cursor: pointer;
					&:hover{
						color: #DA3F34;
					}
				}
				.yixiTallks_bar_active {
					color: #DA3F34;
					border-bottom: 1px solid #DA3F34;
				}
				.yixiTallks_bar_dian {
					width: 18px;
					text-align: center;
				}
				
			}
			
			.yixiTallks_swiper {
				position: relative;
				.swiper {
					.swiper-item {
						height: 562px;
						padding: 33px 70px 80px 70px;
						box-sizing: border-box;
						.swiper_item_content {
							width: 100%;
							height: 100%;
							display: grid;
							grid-template-columns:repeat(3,400px);
							grid-gap:50px;
							// background: pink;
						}
						.video_item {
							height: 143px;
							display: flex;
							background: #fff;
							.videoItem_cover {
								position: relative;
								.videoItem_title {
									width: calc(100% - 40px);
									position: absolute;
									left: 12px;
									bottom: 12px;
									font-size: 14px;
									line-height: 18px;
									color: #fff;
								}
								width: 240px;
								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
							.videoItem_info {
								flex: 1;
								text-align: center;
								padding:10px 0;
								position: relative;
								.speakerAvatar {
									width: 54px;
									height: 54px;
									margin: 0 auto;
									img {
										object-fit: cover;
										border-radius: 50%;
									}
								}
								.speakerName {
									height: 30px;
									padding: 0 25px;
									margin-top: 4px;
									font-size: 12px;
									line-height: 15px;
									font-weight: 500;
									color: #666;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									line-clamp: 2;
									-webkit-box-orient: vertical;
								}
								.speakerIntro {
									height: 30px;
									box-sizing: border-box;
									width: 100%;
									position: absolute;
									bottom: 10px;
									padding: 0 13px;
									font-size: 12px;
									line-height: 15px;
									color: #666;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									line-clamp: 2;
									-webkit-box-orient: vertical;
								}
							}
						}
						.video_item:hover {
							cursor: pointer;
							filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.2));
						}
					}
				}
			}
		}
	}
	.videoPrograms {
		width: 100%;
		padding-top: 90px;
		background: #fff;
		.videoPrograms_content {
			box-sizing: border-box;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: space-between;
			padding: 0 70px;
			margin-top: 50px;
			.videoPrograms_content_item {
				width: 300px;
				height: 300px;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
				span {
					position: relative;
					z-index: 1;
				}
				img {
					position: absolute;
					left: 0;
					top: 0;
					z-index: 0;
				}
				&:hover {
					cursor: pointer;
					filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.4));
				}
			}
		}
	}
	.contactUs {
		background: #fff;
		padding-top: 90px;
		.contactUs_content {
			padding-left: 200px;
			margin-top: 50px;
			display: flex;
			padding-bottom: 300px;
			.concat_methods {
				display: grid;
				grid-template-columns: 240px 215px;
				padding-top: 14px;
				grid-column-gap: 100px;
			}
			.contactUs_content_item {
				position: relative;
				padding-left: 35px;
				font-weight: 500;
				font-size: 18px;
				line-height: 22px;
				cursor: pointer;
				font-family: 'PingFang SC';
				margin-bottom: 43px;
				.icon-item {
					position: absolute;
					top: 0;
					left: 0;
				}
				.icon-item-red {
					opacity: 0;
				}
				&:hover {
					color: #DA3F34;
					.icon-item-red {
						opacity: 1;
					}
				}
			}
			.concat_qcord {
				display: flex;
				flex: 1;
				height: 193px;
				box-sizing: border-box;
				padding:0 150px;
				justify-content: space-between;
				.concat_qcord_item {
					border: 1px solid #DDDDDD;
					border-radius: 6px;
					text-align: center;
					width: 150px;
					padding-top: 12px;
					img {
						width: 120px;
						height: 120px;
					}
					.qcord_item_title {
						margin-top: 5px;
						color: #333333;
						font-weight: 400;
						font-size: 18px;
						line-height: 22px;
						font-family: 'PingFang SC';
					}
				}
			}
		}
	}
	
	
	.info_title {
		display: flex;
		align-items: center;
		justify-content: center;
		.square_title {
			margin: 0 18px;
			font-size: 30px;
			line-height: 40px;
			color: #333333;
			font-family: 'HYXinRenWenSongW';
		}
		.square4 {
			width: 4px;
			height: 4px;
		}
		.square6 {
			width: 6px;
			height: 6px;
			margin: 0 5px;
		}
		.square10 {
			width: 10px;
			height: 10px;
		}
		.square4,.square6,.square10 {
			border-radius: 50%;
			background: #DA3F34;
		}
	}
}
</style>